var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3323 4925 c-248 -67 -415 -316 -381 -568 34 -263 248 -448 517 -448 377 0 626 405 459 743 -41 81 -153 195 -229 232 -116 56 -253 71 -366 41z m216 -333 c59 -30 94 -83 99 -152 5 -73 -8 -109 -59 -154 -110 -100 -273 -50 -309 95 -21 82 27 181 105 215 43 19 124 17 164 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2360 4376 c-173 -35 -506 -101 -739 -147 -311 -61 -432 -88 -454 -103 -100 -67 -91 -221 15 -277 21 -10 53 -19 71 -19 53 0 1503 287 1536 304 69 36 104 114 82 186 -22 75 -83 121 -158 119 -21 0 -180 -29 -353 -63z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368 4341 c-365 -117 -486 -569 -227 -846 103 -109 232 -165 379 -165 143 0 263 53 371 160 150 152 188 389 92 581 -63 127 -166 217 -300 265 -87 30 -228 32 -315 5z m257 -339 c58 -39 88 -102 81 -171 -10 -111 -88 -176 -201 -169 -76 5 -127 38 -156 102 -80 177 116 346 276 238z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3640 3828 c-57 -39 -75 -73 -75 -136 1 -49 42 -169 309 -897 176 -479 319 -854 333 -873 90 -120 288 -53 286 97 0 34 -79 261 -311 894 -171 466 -320 861 -331 876 -44 61 -149 81 -211 39z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474 3220 c-39 -12 -90 -68 -102 -112 -9 -34 3 -1605 13 -1665 7 -38 46 -88 86 -108 36 -19 112 -19 149 0 34 18 75 69 84 107 3 14 1 394 -4 843 -10 778 -11 819 -30 855 -34 67 -122 102 -196 80z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4530 1800 c-223 -30 -402 -210 -441 -443 -42 -253 138 -512 397 -573 234 -55 477 63 580 283 93 197 60 411 -88 569 -119 127 -282 187 -448 164z m150 -342 c63 -33 102 -86 108 -146 11 -123 -68 -212 -191 -212 -206 0 -256 296 -61 365 56 20 94 18 144 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2545 1155 c-687 -101 -1267 -189 -1287 -195 -80 -23 -132 -115 -109 -192 16 -52 54 -94 104 -113 41 -15 63 -13 1346 175 1045 152 1310 194 1335 210 41 24 76 87 76 134 0 92 -65 158 -158 162 -34 2 -560 -71 -1307 -181z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484 1210 c-287 -43 -481 -300 -442 -585 40 -295 328 -496 620 -434 120 26 248 112 319 215 71 104 105 273 80 397 -16 72 -68 179 -118 236 -104 123 -299 195 -459 171z m141 -339 c185 -84 133 -361 -68 -361 -62 0 -105 19 -144 63 -133 151 31 381 212 298z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquare);
export default __webpack_public_path__ + "static/media/square.1d4cfa13.svg";
export { ForwardRef as ReactComponent };